import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleAlbumMetaData: (field: string, value: string | null) => void;
};

export default function PackagingDescriptionFormGroup({
  album,
  readonly,
  disabled,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumMetaData,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.packagingDescription')}
        handleInput={(e) =>
          handleAlbumMetaData('packagingDescription', e.target.value)
        }
        id="packagingDescription"
        type="text"
        value={album.albumMetaData?.packagingDescription?.toString() ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('PackagingDescription')}
        errorMessage={findErrorMessage('PackagingDescription')}
      />
    </div>
  );
}
